import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StorageAuth } from '../../localStorage/StorageAuth';
import { ApiSchemaLogin } from "../../../models/api/apiSchemaLogin";
import { AppUserRoles } from "../../../components/generic/SideNavComponents/menuItemsData";
export type AuthSliceState = {
  isLoggedIn: boolean;
  email?:string;
  userName?:string;
  role?:string;
};

function InitAuthSlice(): AuthSliceState {
  return {
    isLoggedIn: !! StorageAuth.Token,
    email: StorageAuth.Email,
    userName: StorageAuth.UserName,
    role: StorageAuth.Role,
  };
}

const authSlice = createSlice({
  name: "authSlice",
  initialState: InitAuthSlice(),
  reducers: {
    login: (state: AuthSliceState) => {
      state.isLoggedIn = true;
    },

    logout: (state: AuthSliceState) => {
      localStorage.removeItem("Reg_Auth/auth");
      state.isLoggedIn = false;
      state.userName = "";
      state.email = ""; 
      state.role = "";
    },
    SetUserName: (state, action: PayloadAction<string>): void => {
      StorageAuth.UserName = action.payload;
      state.userName = action.payload;
    },
    SetEmail: (state, action: PayloadAction<string>): void => {
      StorageAuth.Email = action.payload;
      state.email = action.payload;
    },
    SetUser: (state, action: PayloadAction< ApiSchemaLogin>): void => {
      StorageAuth.User = action.payload;
    },
    SetUserRole: (state, action: PayloadAction<AppUserRoles>): void => {
      StorageAuth.Role = action.payload;
      state.role = action.payload;
    },
  },
});

export const AuthReducer = authSlice.reducer;
export const AuthActions = authSlice.actions;
